import React, {Component} from "react";
import {connect} from 'react-redux';
import classNames from "classnames";
import FJToolbarCommon from "../view/FJToolbarCommon";
import FJColorContainer from "../view/FJColorContainer";
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import FJWriteIcon from "../../../icon/FJWriteIcon.svg";
import FJToolbarIconButton from "../view/FJToolbarIconButton";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJOverLayPosition from "../view/FJPosition";

class FJToolbarOverLayContainer extends Component{

	render() {
		let {
			active,
			documentColors,
			disabled,
			openTextEditPanel,
      addDocumentColor,
      deleteColor,
      changeColor,
			colors,
			positionChange,
      supportPositions,
      position,
      textData,
		} = this.props;
		let textLength = textData.length;
		return (
			<FJToolbarCommon className={classNames('c-toolbar-text', {active})}>
				{
					colors.map((color, index) => {
					  let tip = index + 1 > textLength ? FJLocalStore._('shape-color') : FJLocalStore._('text-color');
						return (<FJColorContainer hasApplyToAll={false}
                                      useAnchorBody
                                      isTopLayer
						                          documentColors={documentColors}
						                          isSolid={true}
                                      addDocumentColor={addDocumentColor}
                                      deleteColor={deleteColor}
                                      colorDataChange={(type, color) => {changeColor(type, color.mainColor, index)}}
						                          colorData={{mainColor: color}}
						                          tips={tip}
						                          key={index}
						/>);
					})
				}
        <FJToolbarDevider/>
				<FJOverLayPosition disabled={disabled}
                           style={{marginRight: 6}}
                           positionChange={positionChange}
                           positionType={position}
                           supportPositions={supportPositions}
                           placement='bottomCenter'/>
        <FJToolbarIconButton disabled={disabled} className='u-tooltip-bottom'
                             style={{marginRight: 6}}
                             tooltip={FJLocalStore._('edit-text')} onClick={openTextEditPanel}
                             icon={<InlineSVG src={FJWriteIcon} element='div'/>}/>
			</FJToolbarCommon>
		)
	}
}

const mapStateToProps = function (state) {
	return {
		documentColors: state.documentColor.documentColors,
		colors: state.toolOverlay.colors,
    supportPositions: state.toolOverlay.supportPositions,
    position: state.toolOverlay.position,
    textData: state.toolbarText.textData,
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		openTextEditPanel: function () {
			dispatch(FJToolbarAction.showEditTextPanelAction());
		},
    changeColor: function (type, color, index) {
		  dispatch(FJToolbarAction.setOverlayColorAction(type, color, index));
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
		positionChange: function (position) {
		  dispatch(FJToolbarAction.setOverlayPositionAction(position))
		}
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarOverLayContainer);